import { render, staticRenderFns } from "./ThreadStandardAvatarGroup.vue?vue&type=template&id=e58923d6&scoped=true&"
import script from "./ThreadStandardAvatarGroup.vue?vue&type=script&lang=ts&"
export * from "./ThreadStandardAvatarGroup.vue?vue&type=script&lang=ts&"
import style0 from "./ThreadStandardAvatarGroup.vue?vue&type=style&index=0&id=e58923d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e58923d6",
  null
  
)

export default component.exports